import { useNuxtApp } from "#imports";
export const useGraphqlState = function(providedApp) {
  try {
    const app = providedApp || useNuxtApp();
    if (app.$graphqlState) {
      return app.$graphqlState;
    }
  } catch {
  }
  return null;
};
